var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
var ArrowRight = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17.2928932,13 L5,13 L5,12 L17.2928932,12 L13.1452179,7.86036606 C12.9499557,7.66510391 12.9499557,7.34852142 13.1452179,7.15325928 C13.34048,6.95799713 13.6570625,6.95799713 13.8523247,7.15325928 L19.2071068,12.5 L13.8523247,17.8553162 C13.6570625,18.0505783 13.34048,18.0505783 13.1452179,17.8553162 C12.9499557,17.660054 12.9499557,17.3434715 13.1452179,17.1482094 L17.2928932,13 Z" })));
};
ArrowRight.displayName = 'ArrowRight';
export default ArrowRight;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowRight.js.map